const RULESET_VALUE = 'INDIANA';

export const checkRulesetAccess = ruleset => ruleset.toString().toUpperCase() === RULESET_VALUE;

export default checkRulesetAccess;
